/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Link service
 */

namespace Application.Services {
    'use strict';

    import ILink = Models.ILink;
    import Link = Models.Link;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    
    
    /**
     * NetworkService
     */
    export class LinkService {
        public static $name: string = "linkService";
        public static $inject: string[] = ['backendService'];

        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'networknodes/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'links';
        

        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }

        public getAllLinks(): ng.IPromise<ILink[]> {
            return this.backendService.get(this.backendUrl).then(
                (result: ng.IHttpPromiseCallbackArg<IHalList<Link>>) => {
                    return HalConverter.convertList(result.data, Link.Empty);
                });
        }
        
        /**
         * Warning.
         * At the moment this is not exactly an ILink, it needs an object with this info:
         * {from: string, to: string} , instead of two objects with an href attribute inside.
         */
        public saveLink(link: ILink): ng.IPromise<ILink> {
            return this.backendService.post(this.backendUrl, {
                from: link.from.href,
                to: link.to.href,
                networkInterface: link.networkInterface,
            }).then(
                 (result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Link>>) => {
                     return HalConverter.convertElement(result.data, Link.Empty);
                 }
            );
        }
        
        public deleteLinkByHref(href: string): ng.IPromise<boolean> {
            return this.backendService.delete(href);
        }
        
        public deleteLink(link: ILink): ng.IPromise<boolean> {
            return this.backendService.delete(link.href);
        }

        public getLink(href: string): ng.IPromise<ILink> {
            return this.backendService.get(href).then(
                (result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Link>>) => {
                    return HalConverter.convertElement(result.data, Link.Empty);
                });
        }

        public getLinkById(id: number): ng.IPromise<ILink> {
            return this.getLink(this.backendUrl + '/' + id);
        }

    }
}